// "Add this to your phone" — the two halves of it, because the two platforms
// could not be less alike.
//
// Android/Chrome fires `beforeinstallprompt` and lets us show a real install
// button that opens the system dialog. iOS fires nothing and has no API at
// all: the only route is the user tapping Share → Add to Home Screen, so the
// best that can be done is telling them clearly, once.
import { isIOS, isInstalled } from './push';

let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach(fn => fn(canPromptInstall()));

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', e => {
    // Chrome would otherwise show its own mini-infobar at its own moment.
    // Holding it lets the app offer installing where it makes sense instead.
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
  });
}

export const canPromptInstall = () => Boolean(deferredPrompt);

export const onInstallAvailabilityChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

// Opens Chrome's install dialog. Resolves true if they went through with it.
export async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  // A prompt can only be used once; Chrome fires a fresh event if it wants to
  // offer again later.
  deferredPrompt = null;
  notify();
  return outcome === 'accepted';
}

// What to tell someone who can't be given a button. null once there's nothing
// useful left to say — already installed, or Chrome will handle it.
export function installHint() {
  if (isInstalled()) return null;
  if (isIOS()) {
    return 'Tap the Share button at the bottom of Safari, then "Add to Home Screen". Opening it from that icon is also what lets notifications work on iPhone.';
  }
  if (canPromptInstall()) return null;   // there's a button instead
  return null;
}
